import { Base } from "ui/Scripts/source/framework/base";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { IUserListItems, UserListItems } from "./userListItems";

export interface IUsersPage {
    companies: ICompanyMenuItem[];
    userGroups: IIdTitleNode[];
    list: IUserListItems;
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
}

export class UsersPage implements IUsersPage {
    companies: CompanyMenuItem[];
    userGroups: IdTitleNode[];
    list: UserListItems;
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];

    constructor();
    constructor(obj: IUsersPage);
    constructor(obj?: any) {
        this.list = new UserListItems(obj && obj.list || null);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.userGroups = Base.getTypedArray(obj ? obj.userGroups : null, IdTitleNode);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
    }
}